import apiClient, { safeJson } from '@/api/client';
import { ReservationRules, UpdateReservationRulesBody } from './types';

export const getReservationRules = async (centerId: string) => {
    const res = await apiClient.get(`v1/centers/${centerId}/reservation-rules`);
    return { status: res.status, data: await safeJson(res) as { success: boolean; rules: ReservationRules } | null };
};

export const updateReservationRules = async (centerId: string, body: UpdateReservationRulesBody) => {
    const res = await apiClient.put(`v1/centers/${centerId}/reservation-rules`, { json: body });
    return { status: res.status, data: await safeJson(res) as { success: boolean; rules: ReservationRules } | null };
};
